import { BASE_URL } from "../api_const"

export const SUBSCRIBE_BASE_URL = BASE_URL + "/newsletter"
export const SUBSCRIBE_URL = SUBSCRIBE_BASE_URL + "/subscribe"